import {middlewareWrapper} from "utils/middlewareUtils";
import {
  login,
  logout,
  savePushId,
  appBridgeReady,
  appBridgeSleep,
  sbaReady,
  bindToSSO,
  bindToAppbridge,
  LOGIN,
  LOGOUT,
  GET_LOGIN_STATE,
  SBA_READY,
  BIND_SSO_API,
  BIND_APPBRIDGE,
  SSO_LOGIN,
  SSO_LOGOUT,
  SSO_REGISTER,
  SSO_MY_ACCOUNT
} from '../reducers/skysso';
import { loadSubscriptions, resetSubscriptions } from '../reducers/userService';
import { consumerUrl } from 'utils/commonUtils';

const LOGGED_IN_STATE_NAME = "loggedIn";
const INITIATED_LOGIN_COOKIE = "initiated_login";
let sbaBindAttempts = 0;
let appBridgeBindAttempts = 0;
let sba = null;

export default (window, config, client, createMetrics, getMetricsConfig, maxBindRetries = 100, bindRetryPeriod = 100, cookie = require('react-cookie')) => {
    if (!window) {
        return [];
    }

    function getMetrics(store) {
      const metricsConfig = getMetricsConfig(store, config);
      return createMetrics({...metricsConfig});
    }

    function isLocallyLoggedOut(authState) {
      return !authState || !authState.loggedIn;
    }

    function getLoginState(store, next, action) {
      if (action.type === GET_LOGIN_STATE) {
        const {
          getState,
          dispatch
        } = store;
        const authState = getState().common.auth;
        const metrics = getMetrics(store);

        if (window.SkyBetAccount) {
          window.SkyBetAccount.getLoginState((err, data) => {
            if (data && data.name === LOGGED_IN_STATE_NAME) {
              doLocalLogin(data, authState, dispatch, metrics);
              return;
            }

            doLocalLogout(authState, dispatch);
          });          
        }
      }

      return next(action);
    }

    function bindToSSOApi(store, next, action) {
      
      if (action.type === BIND_SSO_API && sbaBindAttempts < maxBindRetries) {
        ++sbaBindAttempts;
        const {dispatch, getState} = store;  

        if (!window.SkyBetAccount) {
          setTimeout(() => dispatch(bindToSSO()), bindRetryPeriod);
          return next(action);
        }
        
        sba = window.SkyBetAccount;
        const metrics = getMetrics(store);
  
        sba.bind('loggedIn', data => {
          const authState = getState().common.auth;
          doLocalLogin(data, authState, dispatch, metrics);
        });

        sba.bind('loggedOut', () => {
          const authState = getState().common.auth;
          doLocalLogout(authState, dispatch);
        });

        sba.setup({
          pollPeriod: 0,
          consumer: 'sportinglife',
          consumerUrl: consumerUrl(),
          host: config.skyBetAccountHost
        });

        sbaBindAttempts = 0;
        dispatch(sbaReady(sba));        
      }
      

      return next(action);
    }

    function bindAppBridge(store, next, action) {
      if ((action.type === SBA_READY || action.type === BIND_APPBRIDGE) && appBridgeBindAttempts < maxBindRetries) {
        ++appBridgeBindAttempts;
        const metrics = getMetrics(store);

        const {dispatch} = store;
        if (!sba) {
            return next(action);
        }

        const appBridge = sba.getAppBridge();
        if (!appBridge) {
          setTimeout(() => dispatch(bindToAppbridge()), bindRetryPeriod);
          return next(action);
        }
        dispatch(appBridgeReady());
        appBridge.consumerReady(true);
        appBridge.trigger('shouldFeedbackIncrement');
        appBridge.bind("setDeviceIDFA", ({
          deviceIDFA
        }) => {
          metrics.api.track("deviceIDFA", {
            deviceIDFA
          });
        });

        appBridge.bind('wake', () => {
          window.location.reload();
        });

        appBridge.bind('sleep', () => {
          dispatch(appBridgeSleep());
        });

        appBridge.bind('notificationToken', (
          deviceName = "",
          timeDeltas = {}
        ) => {
          dispatch(savePushId(deviceName.token));
          metrics.api.track("reportTimings", timeDeltas);
        });

        appBridge.trigger('getDeviceIDFA');
        appBridgeBindAttempts = 0;
      }

      return next(action);
    }

    function ssoLogin(store, next, action) {
        if (action.type === SSO_LOGIN && sba) {
            sba.openLogin();
            cookie.save(INITIATED_LOGIN_COOKIE, "yes", {path: "/"});
        }

        return next(action);
    }

    function ssoLogout(store, next, action) {
        if (action.type === SSO_LOGOUT && sba) {
            sba.logout();
        }

        return next(action);
    }

    function ssoRegister(store, next, action) {
        if (action.type === SSO_REGISTER && sba) {
            sba.openRegistration();
        }

        return next(action);
    }

    function ssoOpenMyaccount(store, next, action) {
      if (action.type === SSO_MY_ACCOUNT && sba) {
          sba.openMyAccount();
      }

      return next(action);
    }    
    
    function loginHandler(store, next, action) {
      if (action.type === LOGIN) {
        const data = action.data;
        const hasUserData = data && data.user && data.user.ssoToken;

        if (hasUserData) {
          client.post(config.api.sso.loggedIn, {data: data.user, withCredentials: true});
        }
      }

      return next(action);
    }

    function logoutHandler(store, next, action) {
      if (action.type === LOGOUT) {
        client.post(config.api.sso.loggedOut, {withCredentials: true});
      }

      return next(action);
    }

    function doLocalLogin(data, state, dispatch, metrics) {
      if (isLocallyLoggedOut(state)) {
        const loggedInHere = cookie.load(INITIATED_LOGIN_COOKIE);
        if (!state.loginInitiated && metrics && !loggedInHere) {
          metrics.api.track("arrivingUser", {custId: data.user.customerId});
        }

        dispatch(login(data));
        dispatch(loadSubscriptions(data));                
      }
    }

    function doLocalLogout(state, dispatch) {
      if (!isLocallyLoggedOut(state)) {
        dispatch(logout());
        dispatch(resetSubscriptions());
      }
    }

    return [
        middlewareWrapper(getLoginState),
        middlewareWrapper(bindToSSOApi),
        middlewareWrapper(bindAppBridge),
        middlewareWrapper(ssoLogin),
        middlewareWrapper(ssoLogout),
        middlewareWrapper(ssoRegister),
        middlewareWrapper(ssoOpenMyaccount),
        middlewareWrapper(loginHandler),
        middlewareWrapper(logoutHandler)
    ];
};


// WEBPACK FOOTER //
// ./modules/Common/middleware/ssoMiddleware.js